import { useQuery } from '@tanstack/react-query'
import { checkExpressAvailability } from '../api/express'
import type { DeliveryLocation } from '../constants/location'
import { QUERY_KEYS } from '../constants/query'
import type { CartLine } from '../helpers/cart'
import { cartVariantIds } from '../helpers/express'

const EXPRESS_CHECK_STALE_MS = 60_000

export function useExpressAvailability(
  lines: CartLine[],
  location: DeliveryLocation | null,
  enabled = true,
) {
  const variantIds = cartVariantIds(lines)
  const lat = typeof location?.lat === 'number' ? location.lat : null
  const lng = typeof location?.lng === 'number' ? location.lng : null
  const canCheck = enabled && variantIds.length > 0 && lat != null && lng != null
  const query = useQuery({
    queryKey: QUERY_KEYS.expressCheck(variantIds.join(','), lat, lng),
    queryFn: () =>
      checkExpressAvailability({
        variantIds,
        latitude: lat as number,
        longitude: lng as number,
      }),
    enabled: canCheck,
    staleTime: EXPRESS_CHECK_STALE_MS,
    refetchOnMount: false,
  })

  return {
    express: canCheck ? (query.data ?? null) : null,
    checking: canCheck && query.isFetching && query.data == null,
  }
}
